export default "__VITE_ASSET__c19c446c__"